import { useEffect } from 'react';

// material-ui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IconBuilding } from '@tabler/icons-react';

// project imports
import { useDispatch, useSelector } from 'store';
import { getMyOrganizations, selectCurrentOrganization } from 'store/slices/organizations';
import { selectAuthUser } from 'store/slices/auth';
import { useNavTheme } from 'contexts/NavThemeContext';

// ==============================|| ORGANIZATION DISPLAY ||============================== //

export default function SearchSection() {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const { mode } = useNavTheme();
  const isLight = mode === 'light';

  // Fetch user's organization on mount
  useEffect(() => {
    if (user?.id) {
      dispatch(getMyOrganizations());
    }
  }, [user?.id, dispatch]);

  // Show nothing if no organization
  if (!currentOrganization) {
    return null;
  }

  return (
    <Box
      sx={{
        ml: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 0.75,
        borderRadius: '8px',
        background: isLight ? 'rgba(0, 0, 0, 0.03)' : 'rgba(255, 255, 255, 0.04)',
        border: `1px solid ${isLight ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.06)'}`,
        transition: 'all 0.2s ease',
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: isLight ? 'rgba(99, 102, 241, 0.1)' : 'rgba(99, 102, 241, 0.15)',
          color: '#6366f1',
        }}
      >
        <IconBuilding stroke={1.5} size="14px" />
      </Box>
      <Typography
        sx={{
          fontSize: '0.8rem',
          fontWeight: 500,
          color: isLight ? '#374151' : 'rgba(255, 255, 255, 0.85)',
          letterSpacing: '0.01em',
        }}
      >
        {currentOrganization.name}
      </Typography>
    </Box>
  );
}
